import { render, staticRenderFns } from "./comments-section.vue?vue&type=template&id=4f765404&scoped=true"
import script from "./comments-section.vue?vue&type=script&lang=js"
export * from "./comments-section.vue?vue&type=script&lang=js"
import style0 from "./comments-section.vue?vue&type=style&index=0&id=4f765404&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f765404",
  null
  
)

export default component.exports